import React from "react"
import { makeStyles } from "@material-ui/styles"
import { Skeleton } from "@material-ui/lab"
import { Box } from "@material-ui/core"
import { visuallyHidden } from "@mui/utils"
import { FlexBox } from "../Boxes/FlexBox"

const useStyles = makeStyles((theme) => ({
  root: {
    background: ({ isThemed }) => (isThemed ? theme.palette.primary.backgroundDark : null)
  }
}))

const LoadingSkeleton = ({
  quantity = 3,
  variant = "text",
  width = "100%",
  height = 20,
  isThemed,
  ariaLabel = "Loading content...",
  ...rest
}) => {
  const classes = useStyles({ isThemed })
  const skeletonQuantity = Array.from({ length: quantity })

  return (
    <FlexBox
      justifyContent="center"
      {...rest}
      flexDirection="column"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={ariaLabel}
    >
      <Box sx={visuallyHidden}>Loading content...</Box>
      {skeletonQuantity.map((_, index) => (
        <Skeleton
          classes={{ root: classes.root }}
          key={index}
          variant={variant}
          width={width}
          height={height}
          aria-hidden="true"
        />
      ))}
    </FlexBox>
  )
}

export { LoadingSkeleton }
